<template>
  <validation-observer
    v-slot="{ errors }"
    ref="capacityObserver"
  >
    <div class="mb-[16px]">
      <label class="text-[14px] mb-[8px] text-[#626262]">
        Kapasitas Tersedia
      </label>
      <div class="flex gap-0 capacity-input-group">
        <div class="flex-grow capacity-value-input">
          <ReusableInput
            v-model="form.capacity"
            name="Nilai Kapasitas"
            label=""
            placeholder="Masukkan kapasitas"
            rules="required"
            :required="true"
            :disabled="isDisabled"
            class="mb-0"
          >
            <template #input="{ value, disabled, onInput, onBlur, onFocus }">
              <b-form-input
                id="input-kapasitas"
                :value="value"
                type="number"
                placeholder="Masukkan kapasitas"
                :disabled="disabled"
                class="!text-[#333333] !border-[#E2E2E2] disabled:!bg-[#F4F4F4] !py-[10px] !rounded-r-[0]"
                @input="onInput"
                @blur="onBlur"
                @focus="onFocus"
              />
            </template>
            <template #error>
              <div />
            </template>
          </ReusableInput>
        </div>
        <div class="capacity-unit-wrapper">
          <ReusableInput
            v-model="form.capacity_type"
            name="Unit Kapasitas"
            label=""
            placeholder="Unit"
            rules="required"
            :required="true"
            :disabled="isDisabled"
            class="mb-0"
          >
            <template #input="{ value, disabled, onInput, onBlur, onFocus }">
              <b-form-select
                id="capacity-unit-select"
                :value="value"
                :options="quantityTypeOptions"
                :disabled="disabled"
                class="!h-full !text-[#333333] !border-[#E2E2E2] disabled:!bg-[#F4F4F4] !py-[10px] !rounded-l-[0] !rounded-r-[0.357rem] !border-l-0"
                @input="onInput"
                @blur="onBlur"
                @focus="onFocus"
              />
            </template>
            <template #error>
              <div />
            </template>
          </ReusableInput>
        </div>
      </div>
      <small
        v-if="printErrors(errors).show"
        class="text-danger d-block mt-1"
      >
        {{ printErrors(errors).message }}
      </small>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import ReusableInput from './Input.vue'
import { quantityTypeOptions } from '../config'

/**
 * CIGWarehouseCapacity
 * @description CIGWarehouseCapacity is a component that displays the capacity of the warehouse
 * @param {Object} form - The form data
 * @param {Boolean} enableEditInput - The enable edit input
 * @returns {Object} CIGWarehouseCapacity
 */
export default {
  name: 'CIGWarehouseCapacity',
  components: {
    ValidationObserver,
    ReusableInput,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    enableEditInput: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      quantityTypeOptions,
    }
  },
  computed: {
    isDisabled() {
      return this.enableEditInput
    },
  },
  methods: {
    printErrors(errors) {
      if (!errors['Nilai Kapasitas'] && !errors['Unit Kapasitas']) {
        return {
          show: false,
          message: '',
        }
      }
      if (errors['Nilai Kapasitas'].length > 0 && errors['Unit Kapasitas'].length > 0) {
        return {
          show: true,
          message: 'Nilai kapasitas dan unit kapasitas wajib diisi',
        }
      }
      if (errors['Nilai Kapasitas'].length > 0 && errors['Unit Kapasitas'].length === 0) {
        return {
          show: true,
          message: errors['Nilai Kapasitas'][0],
        }
      }
      if (errors['Unit Kapasitas'].length > 0 && errors['Nilai Kapasitas'].length === 0) {
        return {
          show: true,
          message: errors['Unit Kapasitas'][0],
        }
      }
      return {
        show: false,
        message: '',
      }
    },
  },
}
</script>

<style scoped>
/* Hide label and error message from nested ReusableInput to maintain clean UI */
.capacity-input-group ::v-deep .form-group {
  margin-bottom: 0 !important;
}

.capacity-input-group ::v-deep small.text-danger {
  display: none !important;
}

/* Remove left border from unit select to make it look connected */
.capacity-unit-wrapper ::v-deep #capacity-unit-select {
  border-left: 0 !important;
}

/* Custom chevron down icon for select */
::v-deep #capacity-unit-select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23333333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 0.75rem center !important;
  background-size: 16px 16px !important;
  padding-right: 2.5rem !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

::v-deep #capacity-unit-select.custom-select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23333333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
}
</style>
